import store from '@/app/store/store';

function createMixPanelTrack(router, to) {
  if (to.name) {
    if (store.getters['account/getActiveAccount']) {
      router.app.$mixpanel.track('navigation', {
        destination: to.path,
        activeAccountID: store.getters['account/getActiveAccount'].uuid,
        accountName: store.getters['account/getActiveAccount'].name,
        accountStatus: store.getters['account/getActiveAccount'].status,
        stripeCustomerID: store.getters['account/getActiveAccount'].stripeCustomerID,
        paymentMethodID: store.getters['account/getActiveAccount'].paymentMethodID,
      });
    }
  }
}

export default createMixPanelTrack;
